document.addEventListener('DOMContentLoaded', () => {
    const lottieContainer1 = document.getElementById('lottie-container-1');
    const lottieContainer2 = document.getElementById('lottie-container-2');

    if (typeof lottie === 'undefined' || (!lottieContainer1 && !lottieContainer2)) {
        return;
    }

    const isMobile = window.innerWidth <= 767;

    const config = {
        desktop: {
            anim1: { delayPx: -2200, speed: 1.9 },
            anim2: { delayPx: -1430,  speed: 1.6 }
        },
        mobile: {
            anim1: { delayPx: -1800,  speed: 1.9 },
            anim2: { delayPx: -1330,  speed: 1.7 }
        }
    };

    const current = isMobile ? config.mobile : config.desktop;

    const animation1 = lottieContainer1 ? lottie.loadAnimation({
        container: lottieContainer1,
        renderer: 'svg',
        loop: true,
        autoplay: false,
        path: '/wp-content/themes/clarent/src/animation/Animation-1.json'
    }) : null;

    const animation2 = lottieContainer2 ? lottie.loadAnimation({
        container: lottieContainer2,
        renderer: 'svg',
        loop: true,
        autoplay: false,
        path: '/wp-content/themes/clarent/src/animation/Animation-2.json'
    }) : null;

    let ticking = false;

    function updateSingleAnimation(container, animation, delayPx, speedMultiplier) {
        if (!container || !animation) return;

        const rect = container.getBoundingClientRect();
        const windowHeight = window.innerHeight;

        const offsetTop = rect.top - delayPx;
        let scrollProgress = (window.scrollY - offsetTop + windowHeight / 2) /
            (rect.height + windowHeight);

        scrollProgress = Math.max(0, Math.min(1, scrollProgress / speedMultiplier));

        const frame = scrollProgress * animation.totalFrames;
        animation.goToAndStop(frame, true);
    }

    function updateAnimations() {
        if (animation1 && lottieContainer1) {
            updateSingleAnimation(
                lottieContainer1,
                animation1,
                current.anim1.delayPx,
                current.anim1.speed
            );
        }

        if (animation2 && lottieContainer2) {
            updateSingleAnimation(
                lottieContainer2,
                animation2,
                current.anim2.delayPx,
                current.anim2.speed
            );
        }

        ticking = false;
    }

    window.addEventListener('scroll', () => {
        if (!ticking) {
            requestAnimationFrame(updateAnimations);
            ticking = true;
        }
    }, { passive: true });

    updateAnimations();
});
